<mat-sidenav-container class="layout-container">
    <!-- Drawer -->
    <mat-sidenav #sidenav mode="side" [opened]="true" class="sidenav slim">
        <div class="logo-container">
            <img src="assets/img/logos/logosm.png" alt="Kasha" class="logo-img" />
        </div>

        <div class="divider"></div>

        <mat-nav-list>
            <a mat-list-item matTooltip="Rider Trips" routerLink="/rider-trips" routerLinkActive="active" (click)="setTitle('Riders & Trips')">
                <mat-icon>directions_walk</mat-icon>
                <span class="label"></span>
            </a>
            <a mat-list-item matTooltip="Facility Incentives" routerLink="/facility-incentives" routerLinkActive="active" (click)="setTitle('Facility Incentives')">
                <mat-icon>local_hospital</mat-icon>
                <span class="label"></span>
            </a>
            <a mat-list-item matTooltip="Deliveries" routerLink="/deliveries" routerLinkActive="active" (click)="setTitle('Deliveries')">
                <mat-icon>local_shipping</mat-icon>
                <span class="label"></span> <!-- hidden in slim mode -->
            </a>
        </mat-nav-list>
    </mat-sidenav>

    <!-- Main -->
    <mat-sidenav-content>
        <!-- White top bar -->
        <mat-toolbar class="topbar white">
            <button mat-icon-button (click)="sidenav.toggle()" class="menu-btn">
                <mat-icon>menu</mat-icon>
            </button>

            <span class="title">{{title}}</span>

            <span class="spacer"></span>

            <button mat-icon-button aria-label="Notifications">
                <mat-icon>notifications</mat-icon>
            </button>
            <button mat-icon-button aria-label="Profile">
                <mat-icon>account_circle</mat-icon>
            </button>
        </mat-toolbar>

        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
